import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ERole } from 'src/app/shared/roles/models/role.enum';
import { RoleService } from '../services/role.service';

/**
 * Restricts a route to only users with the specified roles in the data property 'requireAny'.
 * 
 * If a route has a 'requireAny' data property, the route can only be activated if the user has at least one role in the list.
 *
 * @param {ActivatedRouteSnapshot} route the information about the route
 * @returns true if user has any roles in the route data property, otherwise false
 * @export
 */
export const roleGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
) => {
  const roleService = inject(RoleService);

  if (!route.data
    || !route.data.requireAny
    || !Array.isArray(route.data.requireAny)) return true;

  return roleService.hasAnyRole(route.data.requireAny as Array<ERole>);
};
